module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-sad.afc20c27.png";